import { FreelancersListColumnKeys } from '../declarations/freelancers-list/freelancers-list';
import { FreelancersListItem } from '../typings/freelancers';

export const routeToKeyMap = {
    [FreelancersListColumnKeys.FEEDBACKS_COUNT]: (item: FreelancersListItem): number => item.feedbackCount,
    [FreelancersListColumnKeys.FREELANCER]: (item: FreelancersListItem): string => item.fullName,
    [FreelancersListColumnKeys.REGION]: (item: FreelancersListItem): string => item.region.region,
    [FreelancersListColumnKeys.SCORE]: (item: FreelancersListItem): number => item.freelancerScore,
    [FreelancersListColumnKeys.SERVICES]: (item: FreelancersListItem): number => item.approximatePrice
};
